import { Injectable, inject } from '@angular/core';
import { IdentityConstants } from './identity/identity-constants.service';
import { IdentityUserService } from './identity/identity-user.service';

@Injectable()
export class AuthService {

    identityUserService = inject(IdentityUserService);

    getAuthorizationToken() {
        const authToken = this.identityUserService.getToken() || '';
        return authToken;
    }
}
